import React, { Component } from 'react';
import { TextBox } from 'devextreme-react';
import i18n from '../../../i18n';
import Transformer from '../../../utils/Transformer';
import PropTypes from 'prop-types';

class ReadOnlyCurrencyBox extends Component {
    render() {
        const { value, i18nLabel } = this.props;

        return (
            <div className={'dx-field'}>
                <div className={'dx-field-label'}>
                    {i18n.t(i18nLabel) + ':'}
                </div>

                <div className={'dx-field-value'}>
                    <TextBox
                        className={'multi-language'}
                        name={'name'}
                        value={Transformer.convertCurrency(value)}
                        readOnly={true}
                    />
                </div>
            </div>
        );
    }
}

ReadOnlyCurrencyBox.propTypes = {
    i18nLabel: PropTypes.string,
    value: PropTypes.number
};

export default ReadOnlyCurrencyBox;
